import { TypographyOptions } from '@mui/material/styles/createTypography';

let typography: TypographyOptions = {
  fontFamily: `'Roboto Flex', Lato, sans-serif`,
};

export default typography;
